export default "__VITE_ASSET__B8A88HuY__"